export const userManagement = {
  'columns': [
    {
      'name': '',
      'title': '序号',
      'type':'index',
      'sortable': false,
      'fixed': true
    },
    {
      'name': '',
      'title': '操作,',
      'type':'button',
      'width':'214.5',
      'buttons': [
        {
          "name": "编辑",
          "icon": null,
          "isShow": "function(index, row, button) {return true}",
          "event": {
            "type": "router",
            "params": ["prodPer", "prodBrand"],
            "static": {
              "method": "update"
            },
            "path": "/userManagementList/add",
            "configKey": ""
          }
        },
      {
        "name": "分配角色",
        "icon": null,
        "isShow": "function(index, row, button) {return true}",
        "event": {
          "type": "type-role",
          "path": "",
          "configKey": "/report/meta/sys_code1",
          "params": ["prodPer", "id"],
          "sure": {
            "ajaxType": "post",
            "path": "/report/delete/sys_code",
            "callBack": {
              "autoClose": true
            }
          }
        }
      },
      {
          "name": "有效",
          "icon": null,
          "isShow": "function(index, row, button) {if(row.status === '有效'){ return false} return true}",
          "event": {
            "type": "status-type",
            "ajaxType": "delete",
            "params": [],
            "path": ""
          }
      },
      {
        "name": "无效",
        "icon": null,
        "isShow": "function(index, row, button) { if(row.status === '有效'){ return true} return false}",
        "event": {
          "type": "status-type",
          "ajaxType": "delete",
          "params": [],
          "path": ""
        }
      },{
        "name": "重置密码",
        "icon": null,
        "isShow": "function(index, row, button) {return true}",
        "event": {
          "type": "type-password",
          "path": "",
          "configKey": "/report/meta/sys_code1",
          "params": ["prodPer", "id"],
          "sure": {
            "ajaxType": "post",
            "path": "/report/delete/sys_code",
            "callBack": {
              "autoClose": true
            }
          }
        }
      },],
      'fixed': false
    },
    {
      'name': 'account',
      'title': '用户账号',
      'width':'90',
      'sortable': false,
      'fixed': false
    },
    {
      'name': 'jobNumber',
      'title': '员工编号',
      'width':'90',
      'sortable': false,
      'fixed': false
    },
    {
      'name': 'userName',
      'title': '员工姓名',
      'width':'70',
      'sortable': false,
      'fixed': false
    },{
      'name': 'organizeList',
      'title': '所属组织',
      'type':'link',
      'sortable': false,
      'width':'70',
      'fixed': false,
      'links': [
        {
          "name": "组织详情",
          "icon": null,
          "isShow": true,
          "event": {
            "type": "link-dialog",
            "params": ["prodPer", "prodBrand"],
            "static": {
              "method": "update"
            },
            "path": "",
            "configKey": "%2Freport%2Fmeta%2Fcc_code"
          }
        },
      ]
    },{
      'name': 'roleList',
      'title': '用户角色',
      'width':'70',
      'sortable': false,
      'type':'link',
      'fixed': false,
      'links': [
        {
          "name": "角色详情",
          "icon": null,
          "isShow": true,
          "event": {
            "type": "link-dialog",
            "params": ["prodPer", "prodBrand"],
            "static": {
              "method": "update"
            },
            "path": "",
            "configKey": "%2Freport%2Fmeta%2Fcc_code"
          }
        },]
    },{
      'name': 'mobile',
      'title': '手机号',
      'width':'100',
      'sortable': false,
      'fixed': false
    },{
      'name': 'email',
      'title': '电子邮箱',
      'width':'140',
      'sortable': false,
      'fixed': false
    },{
      'name': 'status',
      'title': '状态',
      'width':'50',
      'sortable': false,
      'fixed': false
    },{
      'name': 'accountType',
      'title': '用户类型',
      'width':'100',
      'sortable': false,
      'fixed': false
    },{
      'name': 'created',
      'title': '创建时间',
      'width':'125',
      'sortable': false,
      'fixed': false
    },{
      'name': 'updatedBy',
      'title': '最近一次修改人',
      'width':'65',
      'sortable': false,
      'fixed': false
    },{
      'name': 'updated',
      'title': '最近一次修改时间',
      'width':'125',
      'sortable': false,
      'fixed': false
    }

  ]
};
export const organization = {
  'columns': [
    {
      'name': '',
      'title': '序号',
      'type':'index',
      'sortable': false,
      'fixed': true
    },
    {
      'name': '',
      'title': '操作,',
      'type':'button',
      'width':'130',
      'buttons': [
        {
          "name": "编辑",
          "icon": null,
          "isShow": "function(index, row, button) {return true}",
          "event": {
            "type": "router",
            "params": ["prodPer", "prodBrand"],
            "static": {
              "method": "update"
            },
            "path": "/organizationManagement/add",
            "configKey": ""
          }
        },
        {
          "name": "有效",
          "icon": null,
          "isShow": "function(index, row, button) {if(row.status === '有效'){ return false} return true}",
          "event": {
            "type": "status-type",
            "ajaxType": "delete",
            "params": [],
            "path": ""
          }
      },
      {
        "name": "无效",
        "icon": null,
        "isShow": "function(index, row, button) { if(row.status === '有效'){ return true} return false}",
        "event": {
          "type": "status-type",
          "ajaxType": "delete",
          "params": [],
          "path": ""
        }
      },{
        "name": "删除",
        "icon": null,
        "isShow": "function(index, row, button) { return true}",
        "event": {
          "type": "delete",
          "ajaxType": "delete",
          "params": [],
          "path": "/report/delete/sys_code"
        }
      }],
      'fixed': false
    },
    {
      'name': 'organizeCode',
      'width':'60',
      'title': '组织编号',
      'sortable': false,
      'fixed': false
    },
    {
      'name': 'organizeName',
      'width':'65',
      'title': '组织名称,',
      'sortable': false,
      'fixed': false
    },
    {
      'name': 'upOrganizeCode',
      'width':'60',
      'title': '上级组织编号,',
      'sortable': false,
      'fixed': false
    },
    {
      'name': 'upOrganizeName',
      'width':'65',
      'title': '上级组织,',
      'sortable': false,
      'fixed': false
    },{
      'name': 'staffName',
      'title': '负责人,',
      'width':'60',
      'sortable': false,
      'fixed': false
    },{
      'name': 'remark',
      'title': '备注',
      'width':'100',
      'sortable': false,
      'fixed': false
    },{
      'name': 'status',
      'title': '状态,',
      'sortable': false,
      'width':'50',
      'fixed': false
    },{
      'name': 'createdBy',
      'title': '创建人',
      'width':'55',
      'sortable': false,
      'fixed': false
    },{
      'name': 'created',
      'title': '创建时间',
      'width':'125',
      'sortable': false,
      'fixed': false
    },{
      'name': 'updatedBy',
      'width':'55',
      'title': '最近一次修改人',
      'sortable': false,
      'fixed': false
    },{
      'name': 'updated',
      'width':'125',
      'title': '最近一次修改时间',
      'sortable': false,
      'fixed': false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/_app/wwka/src/assets/json/tableHead.js